import { useMutation } from "@tanstack/react-query";

import { emailSoilSightLink } from "services";

import { useIsAuthenticated } from "utils";

import { MUTATE_SOIL_SIGHT_LINK_EMAIL } from "consts";

export const useMutateSoilSightLinkEmail = () => {
  const isAuthenticated = useIsAuthenticated();

  return useMutation({
    mutationKey: [MUTATE_SOIL_SIGHT_LINK_EMAIL],
    mutationFn: () => {
      if (!isAuthenticated) {
        return Promise.reject(new Error("Not Authorized"));
      }
      return emailSoilSightLink();
    },
  });
};
